/**
 *
 * Asynchronously loads the component for GenericErrorPopup
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));

export const GenericErrorPopup = loadable(() => import('./index'), {
  resolveComponent: (components) => components.GenericErrorPopup,
});
